import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DepartmentTable from '../../components/DepartmentTable';


function HospitalDepartments() {
  const { hospitalId } = useParams();
  return <DepartmentTable hospitalId={hospitalId}/>
}

export default HospitalDepartments;
